export const FIELD_TYPE_OPTIONS = [
  { value: "short_text", label: "Short Text" },
  { value: "long_text", label: "Long Text" },
  { value: "email", label: "Email" },
  { value: "phone", label: "Phone" },
  { value: "address", label: "Address Line" },
  { value: "state", label: "State (dropdown)" },
  { value: "dropdown", label: "Dropdown" },
  { value: "multiple_choice", label: "Multiple Choice" },
  { value: "checkbox", label: "Checkbox" },
  { value: "date", label: "Date" },
  { value: "number", label: "Number" },
  { value: "file", label: "File Attachment" },
];

export const CANONICAL_MAPPING_OPTIONS = [
  { value: "none", label: "No mapping (custom field)" },
  { value: "first_name", label: "Customer First Name" },
  { value: "last_name", label: "Customer Last Name" },
  { value: "email", label: "Customer Email" },
  { value: "phone", label: "Customer Phone" },
  { value: "street", label: "Service Address — Street" },
  { value: "unit", label: "Service Address — Unit" },
  { value: "city", label: "Service Address — City" },
  { value: "state", label: "Service Address — State" },
  { value: "zip_code", label: "Service Address — ZIP" },
  { value: "description", label: "Request Description" },
];

export const WIZARD_STEPS = [
  { key: "basic", number: 1, label: "Basic Information" },
  { key: "fields", number: 2, label: "Form Fields" },
  { key: "identity", number: 3, label: "Identity Verification" },
  { key: "submission", number: 4, label: "Submission Settings" },
  { key: "review", number: 5, label: "Review & Activate" },
];

export const emptyField = () => ({
  field_id: `_new_${Math.random().toString(36).slice(2, 10)}`,
  type: "short_text",
  label: "",
  placeholder: "",
  description: "",
  required: true,
  options: [],
  canonical_mapping: "none",
});

const _newId = () => `_new_${Math.random().toString(36).slice(2, 10)}`;

export const defaultFields = () => [
  { field_id: _newId(), type: "short_text", label: "First Name", placeholder: "Jane", description: "", required: true, options: [], canonical_mapping: "first_name" },
  { field_id: _newId(), type: "short_text", label: "Last Name", placeholder: "Doe", description: "", required: true, options: [], canonical_mapping: "last_name" },
  { field_id: _newId(), type: "email", label: "Email", placeholder: "jane@example.com", description: "", required: true, options: [], canonical_mapping: "email" },
  { field_id: _newId(), type: "phone", label: "Phone", placeholder: "(555) 123-4567", description: "", required: true, options: [], canonical_mapping: "phone" },
  { field_id: _newId(), type: "address", label: "Street Address", placeholder: "123 Main St", description: "", required: true, options: [], canonical_mapping: "street" },
  { field_id: _newId(), type: "short_text", label: "Unit / Apt", placeholder: "Apt 4B", description: "", required: false, options: [], canonical_mapping: "unit" },
  { field_id: _newId(), type: "short_text", label: "City", placeholder: "Springfield", description: "", required: true, options: [], canonical_mapping: "city" },
  { field_id: _newId(), type: "state", label: "State", placeholder: "Select a state", description: "", required: true, options: [], canonical_mapping: "state" },
  { field_id: _newId(), type: "short_text", label: "ZIP Code", placeholder: "62704", description: "", required: true, options: [], canonical_mapping: "zip_code" },
  { field_id: _newId(), type: "long_text", label: "What do you need help with?", placeholder: "Describe your request...", description: "", required: false, options: [], canonical_mapping: "description" },
];
